/**
 * Tag constants - browser-safe, zero imports.
 * This is the foundation file that other tag files build upon.
 */
// Add future entity types here
const taggingEntityTypes = {
    WORKOUT_PLAN: 'workout_plan',
    MOVEMENT: 'movement',
};
export { taggingEntityTypes };
//# sourceMappingURL=tag.constants.js.map